import React, { useContext, useEffect, useState } from 'react';

import cx from 'classnames';

import _ from 'lodash';

import moment from 'moment';

import Scrollbars from 'react-custom-scrollbars-2';

import EmptyState from 'components/EmptyState';

import Modal from 'components/Modal/Modal';

import RoundedButton from 'components/RoundedButton/RoundedButton';

import DetailsBillingMove from 'Customers/BillingCapacity/DetailsBillingMove';

import styles from './Details.module.scss';

import GenerateProration from './GenerateProration';

import ClientsApi from '../../../../api/ClientsApi';

import modalStyles from '../../../../components/modalStyles';

import TableSkeleton from '../../../../components/skeletons/TableSkeleton';

import Tooltip from '../../../../components/Tooltip';

import formatCurrency from '../../../../utility/formatCurrency';

import { PACKAGE_NAMES } from '../../../constants';

import ClientContext from '../ClientContext';

const addModalStyle = _.cloneDeep(modalStyles);
addModalStyle.content.width = '580px';

const Details = () => {
  const { selected } = useContext(ClientContext);
  const [data, setData] = useState({});
  const [loadingData, setLoadingData] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [clickedOnCopy, setClickedOnCopy] = useState(false);
  const [countInfoOpen, setCountInfoOpen] = useState(false);

  useEffect(() => {
    if (selected) {
      setLoadingData(true);
      const param = selected.id;
      ClientsApi.getTenant(param)
        .then((res) => {
          setData(res.data);
          setLoadingData(false);
        })
        .catch(() => {
          setLoadingData(false);
        });
    }
  }, [selected]);

  useEffect(() => {
    const refreshCapacity = () =>
      ClientsApi.getTenant(selected?.id)
        .then((res) => {
          setData(res.data);
        })
        .catch(() => {});
    window.addEventListener('billing-capacity-changed', refreshCapacity);
    return () => window.removeEventListener('billing-capacity-changed', refreshCapacity);
  }, [selected?.id]);

  if (loadingData) {
    return (
      <div className='me-5'>
        <TableSkeleton lineHight={220} mb='mb-4' num={2} />
      </div>
    );
  }

  const capacity = data?.billingCapacity || data?.details?.billingCapacity || data?.subscription?.billingCapacity;
  const configuredCapacity = capacity && capacity.mode !== 'legacy';
  const prorationUsage = configuredCapacity ? capacity.usage?.active : data?.details?.effectiveUnits;
  const prorationPurchased = configuredCapacity ? capacity.purchased?.active : data?.details?.chargedUnits;

  const copyToClipboard = (str) => {
    const el = document.createElement('textarea');
    el.value = str;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    setClickedOnCopy(true);

    setTimeout(() => {
      setClickedOnCopy(false);
    }, 1000);
  };
  return (
    <div>
      <Scrollbars autoHide className='scroll-bar' style={{ height: 'calc(100vh - 215px)' }}>
        <div className={cx(styles.summaryCards, 'd-flex justify-content-between align-items-start')}>
          <div className='w-50 border rounded p-3 mt-3' style={{ height: '380px' }}>
            <span className='fw-bold mt-1'>Subscription Details</span>
            <div className='d-flex justify-content-between flex-column gap-2 mt-4'>
              <div className='d-flex justify-content-between align-items-center'>
                <p className='fw-bold font-size-12 text-gray mb-2'>Status</p>
                <span className={cx(styles.status, styles[_.camelCase(data?.status)], 'mb-2')}>
                  {_.upperCase(data?.status)}
                </span>
              </div>
              <div className='d-flex justify-content-between  align-items-center '>
                <span className={cx(styles.label)}>Plan name</span>
                <span className={cx(styles.values)}>
                  {PACKAGE_NAMES[data?.details?.planName] || data?.details?.planName || '- -'}
                </span>
              </div>

              <div className='d-flex justify-content-between  align-items-center'>
                <span className={cx(styles.label)}>
                  <span>Charged units</span>
                  <span className='tooltip-box'>
                    <i className='icon-info text-gray ms-2' />
                    <Tooltip label='Number of employees paid for' />
                  </span>
                </span>
                <span className={cx(styles.values)}>{data?.details?.chargedUnits ?? '- -'}</span>
              </div>
              <div className='d-flex justify-content-between  align-items-center'>
                <span className={cx(styles.label)}>
                  <span>{configuredCapacity ? 'HR headcount' : 'Legacy effective units'}</span>
                  <button
                    type='button'
                    className={cx(styles.headcountInfo, 'tooltip-box border-0 bg-transparent p-0')}
                    data-open={countInfoOpen}
                    onFocus={() => setCountInfoOpen(true)}
                    onBlur={() => setCountInfoOpen(false)}
                    onClick={() => setCountInfoOpen(true)}
                    aria-label={configuredCapacity ? 'About HR headcount' : 'About legacy effective units'}
                    aria-describedby='hr-count-help'
                  >
                    <i className='icon-info text-gray ms-2' />
                    <span id='hr-count-help'>
                      <Tooltip
                        label={
                          configuredCapacity
                            ? [
                                'Cached HR employee count, including employees without login access.',
                                'Billing requirements are shown in Current usage and purchased capacity below.',
                              ].join(' ')
                            : [
                                'Cached HR employee count, including employees without login access.',
                                'It may differ from charged units; legacy seat-based billing uses this count.',
                              ].join(' ')
                        }
                      />
                    </span>
                  </button>
                </span>
                <span className={cx(styles.values)}>{data?.details?.effectiveUnits ?? '- -'}</span>
              </div>

              <div className='d-flex justify-content-between  align-items-center'>
                <span className={cx(styles.label)}>Unit Price</span>
                <span className={cx(styles.values)}>
                  {data?.details?.unitPrice != null
                    ? `${data?.details?.currency} ${formatCurrency(data?.details?.unitPrice)}`
                    : '- -'}
                </span>
              </div>
              <div className='d-flex justify-content-between  align-items-center'>
                <span className={cx(styles.label)}>Price</span>
                <span className={cx(styles.values)}>
                  {data?.details?.price != null
                    ? `${data?.details?.currency} ${formatCurrency(data?.details?.price)}`
                    : '- -'}
                </span>
              </div>
              <div className='d-flex justify-content-between  align-items-center'>
                <span className={cx(styles.label)}>MRR</span>
                <span className={cx(styles.values)}>
                  {data?.details?.mrr != null
                    ? `${data?.details?.currency} ${formatCurrency(data?.details?.mrr)}`
                    : '- -'}
                </span>
              </div>
              <div className='d-flex justify-content-between  align-items-center'>
                <span className={cx(styles.label)}>Period</span>
                <span className={cx(styles.values)}>{data?.details?.period ?? '- -'}</span>
              </div>
              <div className='d-flex justify-content-between  align-items-center'>
                <span className={cx(styles.label)}>Next payment</span>
                <span className={cx(styles.values)}>
                  {data?.details?.nextPayment ? moment(data?.details?.nextPayment).format('MMM DD, YYYY') : '- -'}
                </span>
              </div>
              <div className='d-flex justify-content-between  align-items-center'>
                <span className={cx(styles.label)}>Created at</span>
                <span className={cx(styles.values)}>
                  {data?.details?.createdAt ? moment(data?.details?.createdAt).format('MMM DD, YYYY') : '- -'}
                </span>
              </div>
              <div className='d-flex justify-content-between  align-items-center'>
                <span className={cx(styles.label)}>Created By</span>
                <span className={cx(styles.values)}>{data?.createdByEmail ? data?.createdByEmail : '- -'}</span>
              </div>
            </div>
          </div>

          <div className='w-50 border rounded p-3 mx-5 mt-3' style={{ height: '380px' }}>
            <p className='fw-bold mt-1'>Company Responsible</p>
            <p className='fw-bold font-size-12 text-gray mt-4 mb-4'>Primary Representative</p>
            <div className='d-flex justify-content-start flex-column gap-2 w-100'>
              <div className='d-flex justify-content-between align-items-center'>
                <span className={cx(styles.label)}>Name</span>
                <span className={cx(styles.values)}>
                  {data?.firstName || '-'} {data?.lastName || '-'}
                </span>
              </div>
              <div className='d-flex justify-content-between align-items-center'>
                <span className={cx(styles.label)}>Country</span>
                <span className={cx(styles.values)}>{data?.country || '--'}</span>
              </div>
              <div className='d-flex justify-content-between align-items-center'>
                <span className={cx(styles.label)}>Work email</span>
                <div className='text-steal d-flex align-items-start'>
                  <span className={cx(styles.values)}>
                    <a href={`mailto:${data?.details?.workEmail}`}>{data?.details?.workEmail || '- -'}</a>
                  </span>
                  {data?.details?.workEmail && (
                    <div className={cx('ms-2', 'text-gray')}>
                      <div className='tooltip-box'>
                        <i
                          className='icon-copy'
                          onClick={(e) => {
                            e.stopPropagation();
                            copyToClipboard(data?.details?.workEmail);
                          }}
                        />
                        <Tooltip label={clickedOnCopy ? 'Copied' : 'Click to copy'} position={'left'} />
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className='d-flex justify-content-between align-items-center'>
                <span className={cx(styles.label)}>Phone</span>
                <div className='text-steal d-flex align-items-start'>
                  <span className={cx(styles.values)}>{data?.phone || '- -'}</span>
                  {data?.phone && (
                    <div className={cx('ms-2', 'text-gray')}>
                      <div className='tooltip-box'>
                        <i
                          className='icon-copy'
                          onClick={(e) => {
                            e.stopPropagation();
                            copyToClipboard(data?.phone);
                          }}
                        />
                        <Tooltip label={clickedOnCopy ? 'Copied' : 'Click to copy'} position={'left'} />
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className='d-flex justify-content-between align-items-center'>
                <span className={cx(styles.label)}>Job Title</span>
                <span className={cx(styles.values)}>{data?.jobTitle || '- -'}</span>
              </div>
              <div className='d-flex justify-content-between align-items-center'>
                <span className={cx(styles.label)}>Department</span>
                <span className={cx(styles.values)}>{data?.department || '- -'}</span>
              </div>
              <div className='d-flex justify-content-between align-items-center'>
                <span className={cx(styles.label)}>&nbsp;</span>
                <span>
                  {prorationUsage != null && prorationPurchased != null && prorationPurchased < prorationUsage && (
                    <div className={styles.invoiceBtn}>
                      <RoundedButton
                        text='Generate Proration'
                        color='primary'
                        size='sm'
                        onClick={() => {
                          setOpenModal(true);
                        }}
                      />
                    </div>
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
        <DetailsBillingMove
          tenantId={selected?.id}
          summary={data?.billingCapacity || data?.details?.billingCapacity || data?.subscription?.billingCapacity}
        />
        <div className='d-flex justify-content-between align-items-start my-3'>
          <div className='w-50 border rounded p-2'>
            <p className='fw-bold mb-3 mt-1'>Coupons</p>
            <div className={cx(styles.couponsContainer, 'd-flex justify-content-start flex-column gap-2 w-100')}>
              {data?.details?.coupons && data?.details?.coupons?.length > 0 ? (
                data.details.coupons.map((coupon) => (
                  <div className='d-flex justify-content-between align-items-center' key={coupon.id}>
                    <span className={cx(styles.label)}>Coupon Name</span>
                    <span className={cx(styles.values)}>{coupon.id}</span>
                  </div>
                ))
              ) : (
                <EmptyState
                  brandImage='empty-dolar.png'
                  title='No coupons'
                  subtitle='There are no available coupons'
                  showBtn={false}
                />
              )}
            </div>
          </div>
          <div className='w-50 border rounded p-2 mx-5'>
            <p className='fw-bold mb-3 mt-1'>Addons</p>
            <div className={cx(styles.addonsContainer, 'd-flex justify-content-start flex-column gap-2 w-100')}>
              {data?.details?.addons && data?.details?.addons?.length > 0 ? (
                data.details.addons.map((addon) => (
                  <div key={addon.id}>
                    <div className='d-flex justify-content-between align-items-center' key={addon.id}>
                      <span className={cx(styles.label)}>Addon Name</span>
                      <span className={cx(styles.values)}>{PACKAGE_NAMES[addon.name] || addon.name}</span>
                    </div>
                    <div className='d-flex justify-content-between align-items-center' key={addon.id}>
                      <span className={cx(styles.label)}>Price</span>
                      <span className={cx(styles.values)}>{formatCurrency(addon.price)}</span>
                    </div>
                  </div>
                ))
              ) : (
                <EmptyState
                  brandImage='empty-dolar.png'
                  title='No addons'
                  subtitle='There are no additional addons'
                  showBtn={false}
                />
              )}
            </div>
          </div>
        </div>
      </Scrollbars>
      <Modal
        isOpen={openModal}
        shouldCloseOnOverlayClick
        title={'Generate Proration'}
        styles={{
          width: '560px',
          padding: 0,
        }}
        onRequestClose={() => {
          setOpenModal(false);
        }}
      >
        <GenerateProration
          units={configuredCapacity ? prorationUsage : selected?.numberOfEmployees}
          onClose={() => {
            setOpenModal(false);
          }}
        />
      </Modal>
    </div>
  );
};

export default Details;
